// index.js
import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom'; // 只导入 Router
import App from './App';
import './index.css'; // 全局样式
import './i18n'; // i18n 国际化配置

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <React.StrictMode>
    {/* 在这里提供路由环境，App.js 及其子组件都能使用 useNavigate */}
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>
);